var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "p-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "auto" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "授权标题：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入授权标题" },
                        model: {
                          value: _vm.form.order_title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "order_title", $$v)
                          },
                          expression: "form.order_title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "微信用户ID：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入用户ID" },
                        model: {
                          value: _vm.form.to_uid,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "to_uid", $$v)
                          },
                          expression: "form.to_uid",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "授权金额：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入授权金额" },
                        model: {
                          value: _vm.form.order_amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "order_amount", $$v)
                          },
                          expression: "form.order_amount",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "结算时间：" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "value-format": "timestamp",
                          type: "datetime",
                          "unlink-panels": true,
                          placeholder: "选择结算时间",
                        },
                        model: {
                          value: _vm.form.expect_finish_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expect_finish_date", $$v)
                          },
                          expression: "form.expect_finish_date",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }